import IndividualIssue from "./IndividualIssue";

export default IndividualIssue;
